import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { WebShopService } from "../../services/webShop.service";
import { MAX_BASKETITEM_COUNT, WebshopSettingsDataModel2 } from "../../shared/models";
import { IGroupMemberOrderDetailService, IMemberGroupBasketItem, IMemberOrderedItem, IItem, IMemberInfo, IMenuCourse, OrderedItemState, IItemExtra, IMemberInfo_NotificationTyp } from "./groupMemberOrderDetail.facade";
import { InHouseOrderService } from "../../services/inHouseOrder.service";
import { WebShopMode } from "../../services/IWebShopService";
import { Table, POSTable_Item, POSTable_ItemStatus, POSTable_Item_Extra, NotificationTyp, BasketItem, BasketItemExtra } from "../../services/IInHouseOrderService";
import Utils from "../../shared/utils";
import * as moment from "moment";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { Router } from "@angular/router";
import { WarningdialogComponent } from "../../modalDialogs";
import { CoreLogService } from "../../services/log.service";

class MemberGroupBasketItemExtra implements IItemExtra {
  get title(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this._model.name_en) ? this._model.name_de : this._model.name_en;
  }
  get subIndex(): number {
    return 0; //! todo interne verknüpfung muss möglichsein
  }
  get count(): number {
    return this._model.amount;
  }

  constructor(
    private _model: BasketItemExtra
  ) { }
}

class Item implements IItem {
  get id(): number {
    return this._model.product_id;
  }
  get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this._model.name_en) ? this._model.name_de : this._model.name_en;
  }
  get valid_date(): number {
    return this._model.validDate_YMD;
  }
  get deposit(): number {
    return 0;
  }
  get variable_price(): number {
    return 0;
  }
  get extras(): IItemExtra[] {
    return this._extras;
  }
  get count(): number {
    return this._model.amount;
  }
  // Einzelpreis + Deposit
  get price(): number {
    return Utils.centsToCurrency(this._model.price * this._model.amount);
  }
  public get comment(): string {
    return this._model.freetext;
  }
  public set comment(value: string) {
    if (this.canComment) {
      this._model.freetext = value;
      this._service.updateItem(this._model);
    }
  }
  public get canComment(): boolean {
    return (this._service.isOwner) && this._service.canComment;
  }

  public hasComment: boolean = false;


  private _use_menucourse: boolean = true; // initial ist es erlaubt
  public get use_menucourse(): boolean {
    return this._use_menucourse;
  }

  public get menucourse(): number {
    return this._model.menu_course;
  }
  public set menucourse(value: number) {
    this._model.menu_course = value;
    this._service.updateItem(this._model);
  }

  constructor(
    protected _service: GroupMemberOrderDetailService,
    protected _model: BasketItem,
    protected _extras: IItemExtra[],
    menucourses: IMenuCourse[]
  ) {
    const me = this;
    me.hasComment = me._model.freetext !== "";

    // prüfe menügang, wenn es keines von den Angebotenen ist, dann entfernen
    let item_menu_course: IMenuCourse = null;
    if (me._model.menu_course > 0) {
      item_menu_course = menucourses.find((menu_course) => menu_course.id == me._model.menu_course);
    }
    if (!item_menu_course)
      me._use_menucourse = false;
  }
}

class MemberGroupBasketItem extends Item implements IMemberGroupBasketItem {

  constructor(
    _service: GroupMemberOrderDetailService,
    _model: BasketItem,
    menucourses: IMenuCourse[],

  ) {
    super(_service, _model, _model.extras.map((extra) => new MemberGroupBasketItemExtra(extra)), menucourses);
  }

  public get canComment(): boolean {
    return this._service.canComment;
  }

  get canIncrement(): boolean {
    return (this._model.amount < MAX_BASKETITEM_COUNT);
  }
  get canDecrement(): boolean {
    return true; // bei 0 wird artikel entfernt
  }

  increment() {
    if (this.canIncrement) {
      this._service.addCountItem(this._model);
    }
  }

  decrement() {
    if (this.canDecrement) {
      this._service.removeCountItem(this._model);
    }
  }
}

class MemberOrderedItemExtra implements IItemExtra {
  get title(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this._model.name_en) ? this._model.name_de : this._model.name_en;
  }
  get subIndex(): number {
    return 0; //! todo interne verknüpfung muss möglichsein
  }
  get count(): number {
    return this._model.amount;
  }

  constructor(
    private _model: POSTable_Item_Extra
  ) { }
}

class MemberOrderedItem implements IMemberOrderedItem {

  public get id(): number {
    return this._model.id;
  }

  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this._model.name_en) ? this._model.name_de : this._model.name_en;
  }
  public get valid_date(): number {
    return this._model.validDate_YMD;
  }
  public get deposit(): number {
    return 0; //! todo kein deposit bei bestellten artikeln
  }
  public get variable_price(): number {
    return 0; // todo bestellte artikel haben kein variablen Preis momentan
  }
  public get extras(): IItemExtra[] {
    return this.extraItems;
  }
  public get count(): number {
    return this._model.amount;
  }
  // Einzelpreis + Deposit
  public get price(): number {
    return Utils.centsToCurrency(this._model.amount * this._model.price);
  }
  public get comment(): string {
    return ""; // bestellte artikel haben keine Kommentare momentan
  }
  public set comment(value: string) {
    throw new Error("can't change comment");
  }
  public hasComment: boolean = false;

  public get use_menucourse(): boolean {
    return this._model.menuCourse > 0;
  }
  public get menucourse(): number {
    return this._model.menuCourse;
  }
  public set menucourse(value: number) {
    throw new Error("can't change menucourse");
  }

  /** auch InHouseTableOrderOverviewService beachten */
  get state(): OrderedItemState {
    switch (this._model.status) {
      case POSTable_ItemStatus.Orderd:
        return OrderedItemState.InPreperation;
      case POSTable_ItemStatus.Preparing:
        return OrderedItemState.InPreperation;
      case POSTable_ItemStatus.PickUpReady:
        const item = this._model;
        // item gilt nach 10 Minuten automatisch als abgeholt
        if (item.readyAt_YMD > 0) {
          const now = moment();
          const auto_pickedup_at = Utils.GetMomentFromInt(item.readyAt_YMD, item.readyAt_HMS).add(10, "minutes");
          if (now > auto_pickedup_at) {
            return OrderedItemState.PickedUp;
          }
        }
        return OrderedItemState.ReadyForPickUp;
      case POSTable_ItemStatus.Complete:
        return OrderedItemState.PickedUp;
      case POSTable_ItemStatus.NoPreparation:
        return OrderedItemState.None; // todo NoPreparation soll auch ein status bekommen
      case POSTable_ItemStatus.TableService:
        return OrderedItemState.None; // todo TableService fehlt noch
      case POSTable_ItemStatus.Unknown:
        return OrderedItemState.None;
      default:
        return OrderedItemState.None;
    }
  }

  extraItems: MemberOrderedItemExtra[];

  constructor(
    private _service: GroupMemberOrderDetailService,
    private _model: POSTable_Item,
    menucourses: IMenuCourse[]
  ) {
    const me = this;
    me.hasComment = false; // bestellte artikel haben keine Kommentare momentan

    me.extraItems = _model.extras.map((extra) => new MemberOrderedItemExtra(extra));

    // prüfe menügang, wenn es keines von den Angebotenen ist, dann entfernen
    let item_menu_course: IMenuCourse = null;
    if (me._model.menuCourse > 0) {
      item_menu_course = menucourses.find((menu_course) => menu_course.id == me._model.menuCourse);
    }
    if (!item_menu_course) {
      me._model.menuCourse = 0; // remove menucourse
    } // else keeps menucourse
  }
}

class MemberInfo implements IMemberInfo {
  get name(): string {
    return this._name;
  };
  get notificationTyp(): IMemberInfo_NotificationTyp {
    return this._notificationTyp;
  }
  get readyForPickUpCount(): number {
    return this._readyForPickUpCount;
  };

  constructor(
    private _name: string,
    private _notificationTyp: IMemberInfo_NotificationTyp,
    private _readyForPickUpCount: number,
  ) { }
}

@Injectable()
export class GroupMemberOrderDetailService implements IGroupMemberOrderDetailService, OnDestroy {
  private _webshopSettingsChangedSub: Subscription;
  private _inHouseTableChangedSub: Subscription;
  private _inHouseTableClosedSub: Subscription;

  constructor(private _webShopService: WebShopService
    , private _inHouseOrderService: InHouseOrderService
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _router: Router
    , private _coreLogService: CoreLogService) {
  }

  ngOnDestroy(): void {
    // Führt Cleanup durch
    const me = this;

    if (me._webshopSettingsChangedSub)
      me._webshopSettingsChangedSub.unsubscribe();
    if (me._inHouseTableChangedSub)
      me._inHouseTableChangedSub.unsubscribe();
    if (me._inHouseTableClosedSub)
      me._inHouseTableClosedSub.unsubscribe();
  }

  /** der User welcher momentan dargestellt wird */
  private _userToken: string;
  /** cache für die markierten Artikel als gelesen, damit der Counter bleibt auch wenn ein refresh kommt */
  private _excludePickUpReadyItemIDs: number[] = [];

  public initialise(userToken: string): Promise<void> {
    const me = this;

    if (me._userToken)
      throw new Error("initialise runs twice");

    me._userToken = userToken;

    return new Promise<void>(async (resolve, reject) => {

      try {
        const webshopSetting = await me._webShopService.getWebshopSettingsDataModel();
        me.rebindWebshopSetting(webshopSetting);
        me._webshopSettingsChangedSub = me._webShopService.webshopSettingsDataModelObserveChanges.subscribe(async (_) => {
          const webshopSetting = await me._webShopService.getWebshopSettingsDataModel();
          me.rebindWebshopSetting(webshopSetting);
        })

        me._isOwner = me._inHouseOrderService.UserToken == me._userToken;

        const table = await me._inHouseOrderService.GetTable(null); // null damit kein unnötiger Abruf stattfindet
        me.rebindInHouseTable(table);
        me._inHouseTableChangedSub = me._inHouseOrderService.ObserveOnTableChanged.subscribe(async (_) => {
          const table = await me._inHouseOrderService.GetTable(null); // null damit kein unnötiger Abruf stattfindet
          me.rebindInHouseTable(table);
        })

        me._inHouseTableClosedSub = me._inHouseOrderService.ObserveOnTableClosedChanged.subscribe((_) => {
          me.OpenWarningLinkExpired();
        })

        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }


  /** markiere abholbereite artikel als gelesen */
  public async noticeItems(): Promise<void> {
    const me = this;

    const table = await me._inHouseOrderService.GetTable(null); // null damit kein unnötiger Abruf stattfindet
    const itemsForPickUp = me._inHouseOrderService.GetItemsReadyForPickUp(table);
    if (itemsForPickUp.length > 0) {
      const item_ids = itemsForPickUp.map((item) => item.id);
      await me._inHouseOrderService.ItemsNoticed(item_ids);
      me._excludePickUpReadyItemIDs.push(...item_ids);
    }
  };

  private rebindWebshopSetting(webshopSetting: WebshopSettingsDataModel2) {
    const me = this;

    // todo ermitteln ob  _canComment und _menucourses sich geändert haben, den nur dann ist ein rebind sinnvoll

    me.canComment = webshopSetting.use_item_annotation;

    // momentan werden Menügänge nur beim InHouse angeboten
    if (webshopSetting.use_menu_course && me._webShopService.getServiceMode() === WebShopMode.OrderToTable) {
      let menu_courses = webshopSetting.menu_courses.sort((l, r) => l.sortnumber - r.sortnumber);
      // nur menügänge mit sortnumber 1-3
      menu_courses = menu_courses.filter((course) => course.sortnumber > 0 && course.sortnumber < 4);
      // nur die ersten 3 menügänge
      menu_courses = menu_courses.slice(0, 3);
      me._menucourses = menu_courses;
      me._menucoursesSubject.next(me._menucourses);
    } // else keine Menügänge, ui wird sie dann nicht darstellen

    // todo rebind items wegen _canComment und den _menucourses
  }

  private async rebindInHouseTable(table: Table): Promise<void> {
    const me = this;

    const user_group_basket_items = table.yasTable.group_basket_items.filter((item) => item.user_token == me._userToken);
    me._memberGroupBasketItems = user_group_basket_items.map((item) => new MemberGroupBasketItem(me, item, me._menucourses));
    me._memberGroupBasketSubject.next(me._memberGroupBasketItems);

    const user_orderd_items = table.posTable.items.filter((item) => item.userToken == me._userToken);
    me._memberOrderedItems = user_orderd_items.map((item) => new MemberOrderedItem(me, item, me._menucourses));
    me._memberOrderedrItemSubject.next(me._memberOrderedItems);

    let name = "[unknown]";
    let notfificationTyp = IMemberInfo_NotificationTyp.NONE;
    let readyForPickUp = 0;
    let resetPhoneNumber = true;
    const customer = table.yasTable.customers.find((cus) => cus.user_token == me._userToken);
    if (customer) {
      name = customer.nickname;
      if (customer.notification_typ === NotificationTyp.WebPush) {
        notfificationTyp = IMemberInfo_NotificationTyp.WebPush;
      }
      else if (customer.notification_typ === NotificationTyp.FCM) {
        notfificationTyp = IMemberInfo_NotificationTyp.FCM;
      }
      else if (customer.notification_typ === NotificationTyp.SMS) {
        notfificationTyp = IMemberInfo_NotificationTyp.SMS;


        resetPhoneNumber = false;
        me._inHouseOrderService.GetNotificationInfo().then(info => {
          // bei SMS ist es info die Telefonnummer
          me._setPhoneNumber(info);
        }).catch(error => {
          me._coreLogService.error("InHouseTableOrderOverviewService._bindTableSeats", "GetNotificationInfo catch", error);
        });
      } // else keep NONE
      if (me._userToken == me._inHouseOrderService.UserToken) {
        readyForPickUp = me._inHouseOrderService.GetReadyForPickUpCount(table, me._excludePickUpReadyItemIDs);
      }
    }
    if (resetPhoneNumber) {
      me._setPhoneNumber("");
    }

    const memberInfo = new MemberInfo(name, notfificationTyp, readyForPickUp);
    me._memberInfoSubject.next(memberInfo);

    // markiere die neuen artikel als gelesen
    if (me._inHouseOrderService.GetReadyForPickUpCount(table) > 0) {
      me.noticeItems();
    }

    let open_price = me._memberGroupBasketItems.reduce((prevVal, item) => { return prevVal + item.price; }, 0);
    open_price = me._memberOrderedItems.reduce((prevVal, item) => { return prevVal + item.price; }, open_price);
    me._openPriceSubject.next(open_price);
  }

  /** in house settings: customer use Eping */
  public async useNotification(): Promise<boolean> {
    const me = this;
    let useEPing = false;
    const settings = await me._webShopService.getWebshopSettingsDataModel();
    if (settings.in_house_order.use_eping_all_locations) {
      useEPing = true;
    } else if (settings.in_house_order.use_eping_locations && settings.in_house_order.use_eping_locations.indexOf(me._inHouseOrderService.TableData.location) >= 0) {
      useEPing = true;
    }
    return useEPing;
  }

  /** use _setPhoneNumber */
  private _phoneNumber: string = "";
  /** aktualisiert die anzahl offener Artikel */
  private _setPhoneNumber(value: string): void {
    const me = this;
    if (me._phoneNumber != value) {
      me._phoneNumber = value;
      me._phoneNumberSubject.next(value);
    }
  }
  private _phoneNumberSubject: BehaviorSubject<string> = new BehaviorSubject<string>("");
  /** user phone number */
  public get phoneNumber$(): Observable<string> {
    return this._phoneNumberSubject.asObservable();
  }

  /** Menu course */
  private _menucourses: IMenuCourse[] = [];
  private _menucoursesSubject: BehaviorSubject<IMenuCourse[]> = new BehaviorSubject<IMenuCourse[]>([]);
  get menucourses$(): Observable<IMenuCourse[]> {
    return this._menucoursesSubject.asObservable();
  }

  /** Member items in group basket*/
  private _memberGroupBasketItems: MemberGroupBasketItem[] = [];
  private _memberGroupBasketSubject: BehaviorSubject<IMemberGroupBasketItem[]> = new BehaviorSubject<IMemberGroupBasketItem[]>([]);
  get memberGroupBasketItems$(): Observable<IMemberGroupBasketItem[]> {
    return this._memberGroupBasketSubject.asObservable();
  }

  /** Member ordered items*/
  private _memberOrderedItems: IMemberOrderedItem[] = [];
  private _memberOrderedrItemSubject: BehaviorSubject<IMemberOrderedItem[]> = new BehaviorSubject<IMemberOrderedItem[]>([]);
  get memberOrderedItems$(): Observable<IMemberOrderedItem[]> {
    return this._memberOrderedrItemSubject.asObservable();
  }
  /** Member Info */
  private _memberInfoSubject: BehaviorSubject<IMemberInfo> = new BehaviorSubject<IMemberInfo>(null);
  get memberInfo$(): Observable<IMemberInfo> {
    return this._memberInfoSubject.asObservable();
  }

  /** wird nur intern verwendet, achtung bei änderung müssen alle items erneuer werden */
  public canComment: boolean = false;

  /** user is owner (used to allow basket modification and display ready for pick up) */
  private _isOwner: boolean = false
  public get isOwner(): boolean {
    return this._isOwner;
  }
  /** offener gesamt betrag */
  private _openPriceSubject: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  get open_price$(): Observable<number> {
    return this._openPriceSubject.asObservable();
  }

  private _hasChangesSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public get hasChanges$(): Observable<boolean> {
    return this._hasChangesSubject.asObservable();
  }

  /** ändert die Notification auf SMS mit engegebener Nummer */
  public async ChangePhoneNumber(number: string): Promise<boolean> {
    const me = this;
    return me._inHouseOrderService.setNotification("SMS", number);;
  }


  /**
   * Increases item amount by 1 in the group basket
   * Item is identified by user_token + position from the BasketItem
   * Only allowed for group creator and owner of the item
   */
  public async addCountItem(item: BasketItem): Promise<void> {
    const me = this;
    await me._inHouseOrderService.GroupBasket_AddCount(item);
  }


  /**
   * Decreases item amount by 1 in the group basket
   * If amount reaches 0, item will be removed from the basket
   * Item is identified by user_token + position from the BasketItem
   * Only allowed for group creator and owner of the item
   */
  public async removeCountItem(item: BasketItem): Promise<void> {
    const me = this;
    await me._inHouseOrderService.GroupBasket_RemoveCount(item);
  }

  /** überträgt eine änderung am Artikel an den YAS */
  public async updateItem(item: BasketItem): Promise<boolean> {
    const me = this;
    return await me._inHouseOrderService.GroupBasket_UpdateItem(item);
  }

  /** Warning dialog: table / group closed */
  private OpenWarningLinkExpired() {
    const me = this;
    const warningButtomSheet = me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phGroupOrder_LinkExpired_Title"
        , content: "phGroupOrder_LinkExpired_SubText"
        , btnLabel: "phGroupOrder_LinkExpired_Btn"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningButtomSheet.afterDismissed().subscribe((result) => {
      if (result) {
        me._router.navigate(["/menuservice"]);
      }
    });
  }
}